import { createFileRoute } from '@tanstack/react-router'
import { SlidersHorizontalIcon } from 'lucide-react'

import { UnderConstructionPage } from '@/components/under-construction'

export const Route = createFileRoute('/_dashboard/site/$id/drift/settings/')({
  component: () => (
    <UnderConstructionPage
      titleKey="dashboard.sidebar.driftSettingsTitle"
      icon={<SlidersHorizontalIcon className="size-6" />}
      descriptionKey="underConstruction.beforeEndOfYear"
    />
  ),
})
